export default __webpack_public_path__ + "static/media/cancel.83af7b33.svg";